fragment AnalyticsStatusFragment on AnalyticsStatus {
    status
    chatStatus
    latestImpressionData {
        ... on Visit {
            id
            createdTime
        }
        ... on FormSubmission {
            id
            createdTime
        }
    }
    numActiveForms
    numInactiveForms
    trackingScript
    snippetVersion
    authTokenForSnippet
    embeddedDomain
}
